import { useRef } from 'react';
export function useId(provided) {
    var idRef = useRef(provided !== null && provided !== void 0 ? provided : Math.random().toFixed(20).slice(2));
    return idRef.current;
}
//# sourceMappingURL=useId.js.map